
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function PressPage() {
  const pressReleases = [
    {
      date: '2024-01-15',
      title: 'OED Glamping Announces $50M Expansion Across Southeast',
      excerpt: 'Company plans to develop 12 new luxury glamping sites across Alabama, Georgia, and Tennessee over the next three years.',
      category: 'Company News'
    },
    {
      date: '2023-12-08',
      title: 'OED Glamping Wins Sustainable Tourism Award',
      excerpt: 'Recognized for innovative eco-friendly practices and commitment to environmental stewardship in hospitality development.',
      category: 'Awards'
    },
    {
      date: '2023-11-22',
      title: 'Partnership with Alabama State Parks Announced',
      excerpt: 'Strategic partnership will bring luxury glamping experiences to three Alabama state parks starting in 2024.',
      category: 'Partnerships'
    },
    {
      date: '2023-10-10',
      title: 'OED Glamping Reaches 95% Occupancy Rate',
      excerpt: 'Strong demand for outdoor luxury experiences drives record-breaking occupancy rates across all properties.',
      category: 'Performance'
    }
  ];

  const mediaKit = [
    {
      title: 'Company Fact Sheet',
      description: 'Key statistics, milestones, and company overview',
      type: 'PDF'
    },
    {
      title: 'High-Resolution Images',
      description: 'Professional photos of accommodations and properties',
      type: 'ZIP'
    },
    {
      title: 'Executive Bios',
      description: 'Leadership team biographies and headshots',
      type: 'PDF'
    },
    {
      title: 'Logo Package',
      description: 'Brand logos in various formats and sizes',
      type: 'ZIP'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      {/* Hero Section */}
      <section 
        className="relative h-96 bg-cover bg-center bg-no-repeat flex items-center justify-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/f1ac31654df39eb5891ef011d0783326.jpg')`
        }}
      >
        <div className="text-center text-white max-w-4xl mx-auto px-4">
          <h1 className="text-5xl font-bold mb-6">Press & Media</h1>
          <p className="text-xl leading-relaxed">
            Stay updated with the latest news, announcements, and media resources from OED Glamping Retreat Developments.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        
        {/* Press Releases */}
        <section className="mb-16">
          <h2 className="text-4xl font-bold text-gray-900 text-center mb-12">Latest Press Releases</h2>
          
          <div className="space-y-8">
            {pressReleases.map((release, index) => (
              <div key={index} className="bg-white border border-gray-200 rounded-lg p-8 hover:shadow-lg transition-shadow">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-4">
                  <div className="flex items-center space-x-4 mb-4 lg:mb-0">
                    <span className="px-3 py-1 bg-emerald-100 text-emerald-800 rounded-full text-sm font-medium">
                      {release.category}
                    </span>
                    <span className="text-gray-500">{new Date(release.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
                  </div>
                  <button className="text-emerald-600 hover:text-emerald-700 font-semibold cursor-pointer whitespace-nowrap">
                    Read Full Release
                  </button>
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{release.title}</h3>
                <p className="text-gray-600 text-lg">{release.excerpt}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Media Kit */}
        <section className="mb-16 bg-gray-50 rounded-lg p-12">
          <h2 className="text-4xl font-bold text-gray-900 text-center mb-12">Media Kit</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {mediaKit.map((item, index) => (
              <div key={index} className="bg-white rounded-lg p-6 shadow-sm">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-xl font-bold text-gray-900">{item.title}</h3>
                  <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-sm font-medium">
                    {item.type}
                  </span>
                </div>
                <p className="text-gray-600 mb-4">{item.description}</p>
                <button className="bg-emerald-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap">
                  Download
                </button>
              </div>
            ))}
          </div>
        </section>

        {/* Media Contact */}
        <section className="mb-16">
          <h2 className="text-4xl font-bold text-gray-900 text-center mb-12">Media Contact</h2>
          
          <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-lg p-8">
            <div className="text-center mb-8">
              <img 
                src="https://readdy.ai/api/search-image?query=professional%20female%20public%20relations%20manager%20headshot%2C%20corporate%20communications%20director%2C%20media%20relations%20specialist%2C%20business%20professional%20portrait%20with%20confident%20smile&width=200&height=200&seq=media-contact&orientation=squarish"
                alt="Media Contact"
                className="w-24 h-24 rounded-full mx-auto mb-4 object-cover object-top"
              />
              <h3 className="text-2xl font-bold text-gray-900">Sarah Johnson</h3>
              <p className="text-gray-600">Director of Communications</p>
            </div>
            
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-emerald-600 rounded-full flex items-center justify-center">
                  <i className="ri-phone-line text-white"></i>
                </div>
                <div>
                  <p className="font-semibold text-gray-900">Direct Line</p>
                  <p className="text-gray-600">(256) 268-7146 ext. 102</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-emerald-600 rounded-full flex items-center justify-center">
                  <i className="ri-mail-line text-white"></i>
                </div>
                <div>
                  <p className="font-semibold text-gray-900">Email</p>
                  <p className="text-gray-600">press@oedglamping.com</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-emerald-600 rounded-full flex items-center justify-center">
                  <i className="ri-time-line text-white"></i>
                </div>
                <div>
                  <p className="font-semibold text-gray-900">Availability</p>
                  <p className="text-gray-600">Monday - Friday, 9:00 AM - 5:00 PM CST</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Awards & Recognition */}
        <section>
          <h2 className="text-4xl font-bold text-gray-900 text-center mb-12">Awards & Recognition</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-trophy-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Sustainable Tourism Award</h3>
              <p className="text-gray-600">Alabama Tourism Board - 2023</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-star-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Excellence in Hospitality</h3>
              <p className="text-gray-600">Southeast Hospitality Association - 2023</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-leaf-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Green Business Certification</h3>
              <p className="text-gray-600">Environmental Protection Agency - 2022</p>
            </div>
          </div>
        </section>
      </div>
      
      <Footer />
    </div>
  );
}